import React from 'react';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';
import classes from './tags.module.scss';
import { setClassForStatusBubble } from '../../../../utils/helpers';

export const appliedJobsConstant = (t) => {
  return [
    {
      title: t('dashboard.jobs.appliedlist.id'),
      render: (rowData) => {
        return <Link to={`/dashboard/jobs/${rowData?.JobId}`}>{rowData?.Job?.Id}</Link>;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.title'),
      render: (rowData) => {
        return rowData?.Job?.JobTitle;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.type'),
      render: (rowData) => {
        return rowData?.Job?.JobType;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.industry'),
      render: (rowData) => {
        return rowData?.Job?.Industry;
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.status'),
      render: (rowData) => {
        return (
          <div className={`${classes.tags} ${setClassForStatusBubble(rowData?.JobApplicationStatus?.UIName, classes)}`}>
            {rowData?.JobApplicationStatus?.UIName}
          </div>
        );
      }
    },
    {
      title: t('dashboard.jobs.appliedlist.dateapplied'),
      render: (rowData) => {
        return dateFormat(rowData?.CreatedDate, 'dd mmm yyyy');
      }
    }
  ];
};
